import { createContext } from 'react';
import { TrialResourceState } from '../containers/trial6/state/TrialResourceState';
import { V3Routes } from './../routes/index';

type Props = {
    serviceName: string;
    lessonName: string;
    resource: TrialResourceState;
    reservationPagePath: string;
};

export const TrialLpContext: React.Context<Props> = createContext<Props>({
    serviceName: 'SHE',
    lessonName: '体験レッスン',
    resource: new TrialResourceState(),
    reservationPagePath: V3Routes.trialLessons().pathname,
});

type SectionProps = {
    id: string;
    loaded: boolean;
};

export const TrialSectionContext = createContext<SectionProps>({ id: '', loaded: false });
